import {Show, createEffect, createSignal, on, onMount} from 'solid-js'
import './userLoginForm.css'
import {useI18n} from '../../i18n'
import {FocusGroupProvider, FocusableProvider} from '../focus'
import {useSpatialNavigation} from '../../spatialNavigation'
import {useConfig} from '../config/useConfig'
import {isPlatform} from '../../utils'
import { useSelector } from '../../store'

const UserLoginForm = (props: any) => {
    const {getI18n} = useI18n()
    const {getConfig} = useConfig()
    const {setFocus} = useSpatialNavigation()
    const locale = useSelector((state: any) => state?.language?.locale)

    const [usernameRef, setUsernameRef] = createSignal<any>(null)

    const handleUsernameOrEmailChange = (e: {target: {value: any}}) => {
        props.setUsernameOrEmail(e.target.value)
    }

    onMount(() => {
        if (!isPlatform('laptop')) {
            if (document.getElementById('usernameOrEmailLogin')) {
                setFocus(`usernameOrEmailLogin`)
            } else {
                setFocus('loginformbutton')
            }
        }
    })

    createEffect(
        on(
            () => usernameRef(),
            () => {
                if (usernameRef()) {
                    document.getElementById('usernameOrEmailLogin')?.focus()
                }
            }
        )
    )

    return (
        <FocusGroupProvider id={`logintvform-screen`} focusKey={`logintvform-screen`} onFocus={() => {}}>
            <div 
            style={{
                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
            }}
            class={`${getConfig().userAuthType === 'LOGIN' ? 'login-content-tvform-new' : ''} ${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`} 
            >
                {getConfig().userAuthType === 'LOGIN' && <div style='width: 100%;'><div class="client_logo_loading_logout_screen"></div>
                <div class="solo-user-name-heading">{getI18n()?.formatMessage({id: 'LOGIN_WITH_USER_NAME'})}</div></div>}
                <Show when={getConfig().userAuthType === 'BOTH'}>
                    <div class="user-name-heading">{getI18n()?.formatMessage({id: 'LOGIN_WITH_USER_NAME'})}</div>
                </Show>
                <div>
                    <label class="usernameOrEmailLogin" for="usernameOrEmailLogin">
                        {getI18n()?.formatMessage({id: 'USERNAME'})}
                    </label>
                    <FocusableProvider
                        focusKey={`usernameOrEmailLogin`}
                        onFocus={() => {
                            document.getElementById('usernameOrEmailLogin')?.focus()
                        }}
                        onBlur={() => {
                            document.getElementById('usernameOrEmailLogin')?.blur()
                        }}
                    >
                        {(focused: any) => (
                            <input
                                ref={e => {
                                    setUsernameRef(e)
                                }}
                                type="number"
                                id="usernameOrEmailLogin"
                                value={props.usernameOrEmail}
                                onInput={handleUsernameOrEmailChange}
                                required
                                maxLength={getConfig()?.usernameLength}
                                class={`login-input-new ${focused?.() ? 'login-input-new-focus' : ''}`}
                                onClick={() => setFocus('usernameOrEmailLogin')}
                                onKeyDown={(e: KeyboardEvent) => {
                                    if (e.key !== 'Enter') return
                                    props?.onClickLoginButton?.()
                                }}
                            />
                        )}
                    </FocusableProvider>
                </div>
                <div
                    class="user-login-button-container"
                    style={getConfig().userAuthType === 'BOTH' ? {'margin-top': '20px'} : {}}
                >
                    <FocusableProvider
                        id={'loginformbutton'}
                        focusKey={`loginformbutton`}
                        onEnterPress={props.onClickLoginButton}
                        onFocus={() => {
                            document.getElementById('loginbutton')?.focus()
                        }}
                    >
                        {(focused: any) => (
                            <button
                                id="loginbutton"
                                class={`login-content-button-tv-new ${focused?.() ? 'login-content-button-tv-new-focus' : ''}`}
                                tabIndex={focused?.() ? 0 : -1}
                                type="submit"
                                onClick={props.onClickLoginButton}
                            >
                                {getI18n()?.formatMessage({id: 'LOG_IN'})}
                            </button>
                        )}
                    </FocusableProvider>
                    <FocusableProvider id={'whereIsMyUsername'} focusKey={`whereIsMyUsername`} onEnterPress={props.onClickUsernameButton}>
                        {(focused: any) => (
                            <button
                                class={`login-content-button-tv-new ${focused?.() ? 'login-content-button-tv-new-focus' : ''}`}
                                onClick={props.onClickUsernameButton}
                                tabIndex={focused?.() ? 0 : -1}
                            >
                                {getI18n()?.formatMessage({id: 'WHERE_IS_MY_USERNAME'})}
                            </button>
                        )}
                    </FocusableProvider>
                </div>
            </div>
        </FocusGroupProvider>
    )
}

export default UserLoginForm
